import { defineModel } from "../define-model";
import type { ContentFormat, Platform } from "./strategy";

export type PlanItemStatus =
	| "idea"
	| "planned"
	| "in_production"
	| "ready"
	| "scheduled"
	| "published"
	| "skipped";

export type ContentPlanItem = {
	id: string;
	workspaceId: string;
	projectId: string;
	planId: string;
	title: string;
	brief: string;
	hook: string;
	pillar: string | null;
	/** Primary channel (`platforms[0]`); the server keeps both in step. */
	platform: Platform | null;
	platforms: Platform[];
	format: ContentFormat;
	status: PlanItemStatus;
	targetDate: string | null;
	flowId: string | null;
	flowRunId: string | null;
	postId: string | null;
	sortOrder: number;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		contentPlanItem: ContentPlanItem;
	}
}

export const model = defineModel({
	name: "contentPlanItem",
	load: "lazy",
	indexes: ["planId", "projectId"],
	defaults: ({ workspaceId, now }) => ({
		workspaceId,
		brief: "",
		hook: "",
		pillar: null,
		platform: null,
		platforms: [],
		format: "post" as const,
		status: "idea" as const,
		targetDate: null,
		flowId: null,
		flowRunId: null,
		postId: null,
		sortOrder: 0,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) =>
		(a.targetDate ?? "9999").localeCompare(b.targetDate ?? "9999") || a.sortOrder - b.sortOrder,
});
